// extracted by mini-css-extract-plugin
module.exports = {"lightbox-wrapper":"light-box-m__lightbox-wrapper__-jGJf","lightbox":"light-box-m__lightbox__kCcIo","icon-close":"light-box-m__icon-close__1LJtn"};